import React from "react";

const Star = ({ filled }) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill={filled ? "#F2A505" : "#ccc"} // Yellow if filled, gray if not
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.49999 9.35042L9.26665 11.0237C9.77332 11.3304 10.3933 10.8771 10.26 10.3038L9.52666 7.15708L11.9733 5.03708C12.42 4.65042 12.18 3.91708 11.5933 3.87042L8.37332 3.59708L7.11332 0.62375C6.88665 0.08375 6.11332 0.08375 5.88665 0.62375L4.62665 3.59042L1.40665 3.86375C0.819987 3.91042 0.579987 4.64375 1.02665 5.03042L3.47332 7.15042L2.73999 10.2971C2.60665 10.8704 3.22665 11.3237 3.73332 11.0171L6.49999 9.35042Z" />
    </svg>
  );
};

const StarRating = ({ rating }) => {
  const totalStars = 5; // Total number of stars

  return (
    <div style={{ display: "flex", gap: "2px" }}>
      {Array.from({ length: totalStars }, (_, index) => (
        <Star key={index} filled={index < rating} />
      ))}
    </div>
  );
};

export default StarRating;
